export const formatTime = (time) => {
    if (time.substr(2, 1) === ':') {
        return time.substr(0, 5);

    } else {
        return time.substr(11, 5);
    }
}
